import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import DataTable from "react-data-table-component";

import {
  handleGetSubscriptionById,
  handleGetUserSubscriptions,
} from "../../axios";
import { formatDate } from "../../utils/utils";
import CustomLoader from "../CustomLoader";
import NoDataComponent from "../NoDataComponent";

const SubscriptionHistory = () => {
  const { token } = useSelector((state) => state.auth);

  const { id } = useParams();
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  const { data: subscriptionData1, isLoading: loading1 } = useQuery(
    ["subscription", id],
    () => handleGetSubscriptionById(id),
    { enabled: !!id }
  );

  const { data: subscriptionData, isLoading: loading } = useQuery(
    ["subscriptionHistory", subscriptionData1?.data?.[0]?.createdBy?._id],
    () =>
      handleGetUserSubscriptions(
        subscriptionData1?.data?.[0]?.createdBy?._id,
        config
      ),
    { enabled: !!subscriptionData1?.data?.[0]?.createdBy?._id }
  );

  const columns = [
    {
      name: "Order Id",
      selector: (row) => row.OrderId,
      sortable: true,
    },
    {
      name: "Plan / Period",
      selector: (row) =>
        `${row.subscription_plan_type}/${row.subscription_plan_period}`,
      sortable: true,
    },

    {
      name: "Buyer Details",
      cell: (row) => (
        <div>
          <div>
            <p className="font-semibold mt-3">
              Name : <span className="font-normal">{row?.createdBy?.name}</span>
            </p>
            <p className="font-semibold mt-2">
              Email :{" "}
              <span className="font-normal">{row?.createdBy?.email}</span>
            </p>
            <p className="font-semibold mt-2">
              Mobile :{" "}
              <span className="font-normal">{row?.createdBy?.mobile}</span>
            </p>
            <p className="font-semibold mt-2 mb-3">
              Country :{" "}
              <span className="font-normal">{row?.createdBy?.country}</span>
            </p>
          </div>
        </div>
      ),
      width: "250px",
      sortable: true,
    },
    {
      name: "Expiry Date",
      selector: (row) => formatDate(row?.subscription_end_date),
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => `$${row.subscription_amount / 100}.0`,
      sortable: true,
    },
    {
      name: "Subscription Period",
      cell: (row) => (
        <div>
          <p className="font-semibold mt-3">
            Start Date :{" "}
            <span className="font-normal">
              {formatDate(row.subscription_start_date)}
            </span>
          </p>
          <p className="font-semibold mt-2 mb-3">
            End Date :{" "}
            <span className="font-normal">
              {formatDate(row.subscription_end_date)}
            </span>
          </p>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Subscription Id",
      selector: (row) => (row.subscription_id ? row.subscription_id : "free"),
      sortable: true,
      width: "250px",
    },
    {
      name: "GateWay",
      selector: (row) => (row.payment_gateway ? row.payment_gateway : "NA"),
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <div>
          {row.subscription_status === "cancelled" ? (
            <div>
              <p className="font-semibold mt-3">
                Status :{" "}
                <span className="font-normal">{row.subscription_status}</span>
              </p>
              <p className="font-semibold mt-3">
                Cancelled At :{" "}
                <span className="font-normal">
                  {formatDate(row?.subscription_cancelled_at)}
                </span>
              </p>
            </div>
          ) : (
            <p className="font-semibold mt-3">
              Status :{" "}
              <span className="font-normal">{row.subscription_status}</span>
            </p>
          )}
        </div>
      ),
      sortable: true,
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        borderRight: "1px solid #ddd",
        fontWeight: "bold",
        letterSpacing: "0em",
        alignItems: "center",
      },
    },
    cells: {
      style: {
        borderRight: "1px solid #ddd",
        alignItems: "center",
      },
    },
  };

  return (
    <div>
      <div>
        <p className="font-semibold antialiased tracking-wide text-[22px]">
          Subscription History
        </p>
      </div>
      <div className="ring-2 ring-gray-200 border-gray-200 mt-6">
        <DataTable
          columns={columns}
          data={subscriptionData?.data}
          progressPending={loading}
          progressComponent={loading ? <CustomLoader /> : "NoData"}
          customStyles={customStyles}
          noDataComponent={<NoDataComponent />}
          responsive
        />
      </div>
    </div>
  );
};

export default SubscriptionHistory;
